import * as CONSTANTS from "./../Constants/AssetTypeConstants";
import { AssetTypeUtility } from "../Utility/AssetTypeUtility";
import { AssetTypeInitialState } from "../Constants/AssetTypeInitialState";

export class AssetTypeActions {

    cleanDashboard = (payload) => {
        return { type: CONSTANTS.CLEAN_ASSETTYPE_DASHBOARD, payload }
    }


    loadAssetTypeDashboard = (payload) => {
        return dispatch => {
            payload.isOngoingLoading = true;
            dispatch(this.loadAssetTypeDashboardAsync(payload));
            payload.apiObject.getAssetTypeDetails(payload.objectType, payload.offset, payload.limit)
                .then((response) => {
                    payload.isOngoingLoading = false;
                    payload.AssetTypes = response[0].data;
                    dispatch(this.loadAssetTypeDashboardAsync(payload));
                }).catch((error) => {
                    console.error("Error: ", error);
                    payload.hideAlert = false;
                    payload.alertHeader = "Ooops!!";
                    payload.alertSubText = "Error while loading AssetTypes";
                    dispatch(this.openCloseAlertModal(payload));

                    setTimeout(() => {
                        payload.hideAlert = true;
                        payload.alertHeader = "";
                        payload.alertSubText = "";
                        dispatch(this.openCloseAlertModal(payload));
                    }, 2000);
                })
        }
    }

    loadAssetTypeDashboardAsync = (payload) => {
        return { type: CONSTANTS.LOAD_ASSETTYPE_DASHBOARD, payload }
    }

    loadAttributeDropDowns = (payload) => {
        return dispatch => {
            payload.isOngoingLoading = true;
            dispatch(this.loadAttributeDropDownsAsync(payload));
            payload.apiObject.getAllFormAttributes(payload.objectType)
                .then((response) => {
                    payload.isOngoingLoading = false;
                    payload.FormAttributes = response.data;
                    dispatch(this.loadAttributeDropDownsAsync(payload));
                }).catch((error) => {
                    console.error("Error: ", error);
                    payload.hideAlert = false;
                    payload.alertHeader = "Ooops!!";
                    payload.alertSubText = "Error while loading Attributes";
                    dispatch(this.openCloseAlertModal(payload));

                    setTimeout(() => {
                        payload.hideAlert = true;
                        payload.alertHeader = "";
                        payload.alertSubText = "";
                        dispatch(this.openCloseAlertModal(payload));
                    }, 2000);
                })
        }
    }

    loadAttributeDropDownsAsync = (payload) => {
        return { type: CONSTANTS.LOAD_ASSETTYPE_ATTRIBUTES, payload }
    }

    sortAssetTypeDashboard = (payload) => {
        return { type: CONSTANTS.SORT_ASSETTYPE_DASHBOARD, payload }
    }

    changeAssetTypeNameFilterValue = (payload) => {
        return { type: CONSTANTS.CHANGE_ASSETTYPE_NAME_FILTER_VALUE, payload }
    }

    changeAssetTypeTab = (payload) => {
        return { type: CONSTANTS.CHANGE_ASSETTYPE_TAB, payload }
    }

    closeAssetTypePanel = (payload) => {
        return { type: CONSTANTS.CLOSE_ASSETTYPE_DETAILS_PANEL, payload }
    }

    changeAssetTypeDescription = (payload) => {
        switch (payload.field) {
            case "name":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_NAME, payload }

            case "acronymCode":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_ACRONYM_CODE, payload }

            case "description":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_DESCRIPTION, payload }

            case "displayName":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_DISPLAY_NAME, payload }

            case "category":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_CATEGORY, payload }

            default:
                break;
        }
    }

    changeAssetTypeAttributes = (payload) => {
        switch (payload.field) {
            case "form":
                return { type: CONSTANTS.CHANGE_ASSETTYPE_FORM_ATTRIBUTE, payload }

            default:
                break;
        }
    }

    // Save Asset Type
    saveAssetTypeDetails = (payload) => {
        return { type: CONSTANTS.SAVE_ASSETTYPE_DETAILS, payload };
    }

    saveAssetTypeDetailsAsync = (payload) => {
        return dispatch => {
            payload.isOnGoingSave = true;
            dispatch(this.saveAssetTypeDetails(payload));

            let utility = new AssetTypeUtility();
            let assetTypePayload = utility.generateAssetTypeJSONPayLoad(payload.CurrentAssetType);

            payload.apiObject.saveAssetTypeConfigData(assetTypePayload).then((response) => {
                payload.isOnGoingSave = false;
                dispatch(this.saveAssetTypeDetails(payload))
                payload.hideAlert = false;
                payload.alertHeader = "Success !!";
                payload.alertSubText = "Data saved successfully";
                dispatch(this.openCloseAlertModal(payload));

                setTimeout(() => {
                    payload.hideAlert = true;
                    payload.alertHeader = "";
                    payload.alertSubText = "";
                    payload.objectType = "AssetType";
                    payload.offset = 0;
                    payload.limit = AssetTypeInitialState.limit;
                    dispatch(this.openCloseAlertModal(payload));
                    dispatch(this.cleanDashboard(payload));
                    dispatch(this.closeAssetTypePanel(payload));
                    dispatch(this.loadAssetTypeDashboard(payload));
                }, 2000);

            }).catch((error) => {
                console.error("Error: ", error);

                payload.hideAlert = false;
                payload.alertHeader = "Error !!";
                payload.alertSubText = "Error while saving Asset Type Details";
                dispatch(this.openCloseAlertModal(payload));

                setTimeout(() => {
                    payload.hideAlert = true;
                    payload.alertHeader = "";
                    payload.alertSubText = "";
                    dispatch(this.openCloseAlertModal(payload));
                }, 2500);

            })
        }
    }

    openCloseAlertModal = (payload) => {
        return { type: CONSTANTS.OPEN_CLOSE_ASSET_TYPES_ALERT_MODAL, payload };
    }

    openCloseAssetTypeConfirmModal = (payload) => {
        return { type: CONSTANTS.OPEN_CLOSE_ASSETTYPE_CONFIRM_MODAL, payload };
    }

    deleteAssetType = (payload) => {
        return { type: CONSTANTS.DELETE_ASSET_TYPE, payload };
    }

    deleteAssetTypeAsync = (payload) => {
        return dispatch => {
            payload.isOngoingDelete = true;
            dispatch(this.deleteAssetType(payload));

            payload.apiObject.deleteAssetType(payload.CurrentAssetType).then((response) => {
                payload.isOngoingDelete = false;
                payload.CurrentAssetType = response.data;
                dispatch(this.deleteAssetType(payload))
                payload.hideAlert = false;
                payload.alertHeader = "Success !!";
                payload.alertSubText = "Asset Type Archived successfully. Please refresh to check data";
                dispatch(this.openCloseAlertModal(payload));

                setTimeout(() => {
                    payload.hideAlert = true;
                    payload.alertHeader = "";
                    payload.alertSubText = "";
                    dispatch(this.openCloseAlertModal(payload));
                }, 2000);

            }).catch((error) => {
                console.error("Error: ", error);

                payload.hideAlert = false;
                payload.alertHeader = "Error !!";
                payload.alertSubText = "Error while deleting Asset Type";
                dispatch(this.openCloseAlertModal(payload));

                setTimeout(() => {
                    payload.hideAlert = true;
                    payload.alertHeader = "";
                    payload.alertSubText = "";
                    dispatch(this.openCloseAlertModal(payload));
                }, 2500);

            })
        }
    }

}